<template>
    <div v-if="showPrice" class="activity-card-price-block">
        <strong data-cy="client-price">{{ $t('from') }} {{ $filters.price(offer.price) }}</strong>
        <discount-label :price="offer.price" />
        <commission-amount :commission="offer.price.commission" />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import DiscountLabel from '@/components/snippets/DiscountLabel.vue'
    import CommissionAmount from '@/components/snippets/CommissionAmount.vue'

    @Component({
        components: {CommissionAmount, DiscountLabel},
    })
    export class ActivityCardPriceBlock extends Vue {
        @Prop({default: () => ({})}) offer

        get showPrice() {
            return true
        }
    }

    export default ActivityCardPriceBlock
</script>
